<template>
  <div
    class="flex px-3 pb-6 tile-wrapper"
    :class="[
      tileView === 'grid'
        ? 'flex-col lg:w-1/3 md:w-1/2 w-full'
        : 'flex-row w-full tile-list-view',
    ]"
    :style="[customCss]"
  >
    <div
      class="w-full flex overflow-hidden shadow-lg btn-radius h-full tile-wrapper"
      :class="[tileView === 'grid' ? 'flex-col' : 'flex-col md:flex-row']"
    >
      <div
        class="static w-full"
        :class="[tileView === 'grid' ? '' : 'md:w-1/3 md:h-auto']"
      >
        <div class="w-full h-full" v-if="cover">
          <div class="w-full h-full relative pb-40">
            <img :src="cover" alt="" class="w-full h-full absolute" />
          </div>
          <div
            class="absolute left-0 top-0 w-full h-full flex items-center justify-center text-white text-xl font-bold opacity-0 z-10 tile-heading-color"
            :class="hoverTitle == 'Example Only' ? 'hover:opacity-100' : ''"
          >
            <div class="text-center px-4">{{ hoverTitle }}</div>
          </div>
        </div>
        <div
          v-else
          class="tile-heading-color w-full h-full flex items-center justify-center text-white text-xl font-bold uppercase relative pb-40"
        >
          <div
            class="text-center px-4 absolute top-0 bottom-0 items-center flex"
          >
            {{ title }}
          </div>
        </div>
      </div>

      <div
        class="p-6 pb-20 w-full flex-1 relative body-tile-bg-color"
        :class="[tileView === 'grid' ? '' : 'md:w-3/4']"
      >
        <div class="flex flex-col">
          <div
            class="title-text text-xl campton-font font-bold mb-4 body-heading-color"
          >
            {{ title }}
          </div>
          <div
            class="text-base campton-font text-grey-500 body-content-color"
            :class="[tileView === 'grid' ? '' : 'md:h-10']"
          >
            {{ description.substring(0, 100) }}
            {{ description.length >= 100 ? '...' : '' }}
          </div>
        </div>
        <div
          class="flex flex-col space-y-4"
          :class="[
            tileView === 'grid'
              ? ''
              : 'md:flex-row md:justify-between md:space-y-0',
          ]"
        >
          <div
            class="w-full absolute left-0 bottom-0 p-6"
            :class="[tileView === 'grid' ? '' : 'w-full']"
          >
            <slot name="button"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tile',
  props: {
    cover: {},
    tileView: {
      default: 'list',
    },
    title: {
      type: String,
      required: true,
    },
    hoverTitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    getThemeSettings: {
      type: Function,
      required: true,
    },
  },
  methods: {},
  computed: {
    customCss() {
      return {
        '--template-body-tile-bg-color': this.themeSettings.body_section
          .tile_bg_color,
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
        '--template-body-content-color': this.themeSettings.body_section
          .body_content_color,
        '--template-section-color-tile': this.themeSettings
          .configuration_options.section_heading_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss">
.course-img-hover {
  background: rgba(105, 147, 248, 0.8);
}
.body-tile-bg-color {
  background: var(--template-body-tile-bg-color);
}
.body-content-color {
  color: var(--template-body-content-color);
}
.body-heading-color {
  color: var(--template-body-heading-color);
}
.tile-heading-color {
  background-color: #0047ff;
}
.tile-wrapper .title-text {
  line-height: normal;
}
.tablet-template,
.mobile-template {
  .tile-wrapper {
    .pb-40 {
      padding-bottom: 12rem;
    }
  }
}
.tablet-template {
  .tile-list-view {
    .md\:w-1\/3 {
      width: 40%;
    }
  }
}
.mobile-template {
  .tile-list-view {
    .md\:w-1\/3,
    .md\:w-3\/4 {
      width: 100%;
    }
    button {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 992px) {
  .tile-wrapper {
    .pb-40 {
      padding-bottom: 12rem;
    }
  }
  .tile-list-view {
    .md\:w-1\/3 {
      width: 40%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .tile-wrapper {
    .pb-40 {
      padding-bottom: 13rem;
    }
  }
  .tile-list-view {
    .md\:w-1\/3,
    .md\:w-3\/4 {
      width: 100%;
    }
    button {
      width: 100%;
    }
  }
}
</style>
